// @ts-ignore
import { Component, OnInit } from '@angular/core';
import posts from '../inside/posts_data.json';
import {Meta, Title} from "@angular/platform-browser";

// @ts-ignore
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  public postData: { id: string, category: string, title: string, creator: string, date: string, imagepath: string}[] = posts;
  customOptions: any = {
    loop: true,
    nav: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<div class="gallery"><div class="prev"><i class="fa fa-chevron-left left"></i></div>', '<div class="next"><i class="fa fa-chevron-right right"></i></div></div>'],
    responsive: {
      0: {
        items: 1
      },
      1200: {
        items: 2
      }
    },
  };
  constructor(private meta: Meta, private titleService: Title) { }
  ngOnInit() {
    window.scrollTo(0, 0);
    this.titleService.setTitle('OXLDigital | Technology partner | IT Services | Marketing');
    // tslint:disable-next-line:max-line-length
    this.meta.updateTag({ name: 'description', content: 'OxlDigital automates your marketing, supercharges analytics, and scales revenue' });
  }
}
